<div [hidden]="!isOpen" #modal>
    <div class="modal__overlay" (click)="close(true)" id="modal_close_overlay"></div>
    <div class="modal" [ngClass]="sizeClass">
        <div style="text-align: right;position: absolute;right: 0;">
            <button (click)="close(false)" [hidden]="!options || !options.closeButton" id="modal_close_button"
                    aria-label="Close"
                    class="modal__close-btn">
                <span class="sc-icon icon-close-elipse" 
                [ngClass]="{'modal__icon-primary': options && options.closeButtonColor === 'primary', 
                'modal__icon-secondary': options && options.closeButtonColor === 'secondary',
                'sc-icon-2x': options && options.closeButtonSize === 'medium',
                'sc-icon-3x': options && options.closeButtonSize === 'large'}">
            </span>
            </button>
        </div>
        <div class="modal__body" [ngStyle]="{'background-color': options && options.bodyColor ? options.bodyColor: '', 'padding': options && options.noPadding ? 0 : ''}">
            <div class="modal__body-wrapper" [ngStyle]="{ 'text-align': 'center', 'padding-top': contentPadding }">
                <h1 *ngIf="options && options.title" class="modal__title" [innerHTML]="options?options.title:options"></h1>
                <div class="modal__info">
                    <span *ngIf="options && options.body" [innerHTML]="options.body"></span>
                    <ng-container *ngIf="options && !options.body">
                        <ng-content></ng-content>
                    </ng-container>
                </div>
                <div class="modal__buttonsBox" #buttonsBox>
                </div>
            </div>
        </div>
    </div>
</div>